import * as React from 'react';
import Svg, {Path, Circle} from 'react-native-svg';

interface NoMobileOrderLocationProps {
  color?: string;
}

function NoMobileOrderLocation(props: NoMobileOrderLocationProps) {
  return (
    <Svg width={73} height={72} viewBox="0 0 73 72" fill="none" {...props}>
      <Path
        d="M63.5 30c0 21-27 39-27 39s-27-18-27-39a27 27 0 1154 0z"
        fill={props.color ?? '#003349'}
      />
      <Path d="M36.5 39a9 9 0 100-18 9 9 0 000 18z" fill="#003349" />
      <Path
        d="M63.5 30c0 21-27 39-27 39s-27-18-27-39a27 27 0 1154 0z"
        stroke={props.color ?? '#003349'}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M36.5 39a9 9 0 100-18 9 9 0 000 18z"
        stroke={props.color ?? '#003349'}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Circle cx={36.558} cy={29.223} r={9.6} fill="#F1F5F5" />
    </Svg>
  );
}

export default NoMobileOrderLocation;
